import { Clock, CheckCircle2, AlertTriangle } from "lucide-react";

const MAP = {
  in_verifica: { cls: "bg-amber-100 text-amber-700", icon: Clock, label: "Addebito in verifica" },
  attivo: { cls: "bg-emerald-100 text-emerald-700", icon: CheckCircle2, label: "Attivo" },
  addebito_fallito: { cls: "bg-red-100 text-red-700", icon: AlertTriangle, label: "Addebito rifiutato" },
};

export const SepaStatusBadge = ({ status, className = "" }) => {
  const cfg = MAP[status];
  if (!cfg) return null;
  const Icon = cfg.icon;
  return (
    <span data-testid={`sepa-status-${status}`}
      className={`inline-flex items-center gap-1 text-[10px] font-semibold px-1.5 py-0.5 rounded-full ${cfg.cls} ${className}`}>
      <Icon className="h-2.5 w-2.5" />{cfg.label}
    </span>
  );
};
